import { render, staticRenderFns } from "./AddImoveltipoPage.vue?vue&type=template&id=60af27cc&"
import script from "./AddImoveltipoPage.vue?vue&type=script&lang=js&"
export * from "./AddImoveltipoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports